import React from 'react'
import emptyImg from '../../images/search_none_img.png'


export default function (props) {
    return (
        <div className="list-empty text-center">
            <div>
                <img src={emptyImg} alt=""/>
                <div className="text">
                    <p>没有更多的搜索结果</p>
                </div>
            </div>
        </div>
    )
}


// WEBPACK FOOTER //
// ./src/components/liveroomLecturer/SearchEmpty.js